import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format currency
export function formatCurrency(amount, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

// Format number with K/M suffix
export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toString();
}

// Format relative time
export function formatRelativeTime(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHour < 24) return `${diffHour}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric' 
  });
}

// Calculate momentum display color
export function getMomentumColor(score) {
  if (score >= 100) return 'text-red-500';
  if (score >= 50) return 'text-orange-500';
  if (score >= 20) return 'text-yellow-500';
  return 'text-slate-500';
}

// Get trust level badge classes
export function getTrustBadgeClass(level) {
  const classes = {
    new: 'trust-new',
    active: 'trust-active',
    verified: 'trust-verified',
    mentor: 'trust-mentor',
  };
  return classes[level] || classes.new;
}

// Get category icon name
export function getCategoryIcon(categoryId) {
  const icons = {
    tech: 'Code',
    creative: 'Palette',
    social: 'Heart',
    education: 'BookOpen',
    health: 'Activity',
    finance: 'Briefcase',
    games: 'Gamepad2',
    other: 'Box',
  };
  return icons[categoryId] || 'Box';
}

// Validate URL
export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch {
    return false;
  }
}

// Truncate text
export function truncateText(text, maxLength = 100) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '...';
}

// Generate avatar placeholder
export function getAvatarFallback(name) {
  if (!name) return 'U';
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

// Money boost options
export const MONEY_BOOST_OPTIONS = [
  { amount: 5, label: '$5', score: 5 },
  { amount: 10, label: '$10', score: 8 },
  { amount: 25, label: '$25', score: 12 },
  { amount: 50, label: '$50', score: 15 },
  { amount: 100, label: '$100', score: 18 },
];

// Feed types - labels are i18n keys
export const FEED_TYPES = [
  { id: 'trending', labelKey: 'feed.trending', icon: 'TrendingUp' },
  { id: 'rising', labelKey: 'feed.rising', icon: 'Rocket' },
  { id: 'community', labelKey: 'feed.community', icon: 'Users' },
  { id: 'smart_picks', labelKey: 'feed.smart_picks', icon: 'Star' },
  { id: 'latest', labelKey: 'feed.latest', icon: 'Clock' },
];

// Legal disclaimer text
export const LEGAL_DISCLAIMER = 
  "This platform does not offer investments. All contributions are voluntary support. No equity, profit, or financial return is promised.";
